import React, { useState } from 'react';
import { PinType, PIN_TYPES } from '../models/PinType';

interface AddPinModalProps {
  latitude: number;
  longitude: number;
  onSubmit: (type: PinType, title: string, description: string, hasLiveChat: boolean) => void;
  onCancel: () => void;
}

// Mirrors iOS AddPinView — drop a pin, pick a type, describe it
const AddPinModal: React.FC<AddPinModalProps> = ({ latitude, longitude, onSubmit, onCancel }) => {
  const [type, setType] = useState<PinType>(PinType.HAZARD);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [hasLiveChat, setHasLiveChat] = useState(false);

  const selectableTypes = Object.values(PinType).filter(t => t !== PinType.BUSINESS);
  const isValid = title.trim().length > 0 && description.trim().length > 0;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1100, backdropFilter: 'blur(8px)'
      }}
      onClick={e => { if (e.target === e.currentTarget) onCancel(); }}
    >
      <div style={{
        backgroundColor: 'white', borderRadius: '16px', padding: '24px',
        width: '90%', maxWidth: '420px', maxHeight: '85vh', overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <h2 style={{ margin: '0 0 4px', fontSize: '20px' }}>📍 Drop a Pin</h2>
        <p style={{ margin: '0 0 16px', fontSize: '13px', color: '#666' }}>
          {latitude.toFixed(5)}, {longitude.toFixed(5)}
        </p>

        <label style={{ fontSize: '13px', fontWeight: 600, color: '#444' }}>Type</label>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '8px', margin: '8px 0 16px'
        }}>
          {selectableTypes.map(t => {
            const info = PIN_TYPES[t];
            const selected = t === type;
            return (
              <button
                key={t}
                onClick={() => setType(t)}
                style={{
                  padding: '10px 6px', borderRadius: '10px', cursor: 'pointer',
                  border: `2px solid ${selected ? info.color : '#e0e0e0'}`,
                  backgroundColor: selected ? `${info.color}15` : 'white',
                  fontSize: '12px', fontWeight: selected ? 700 : 500
                }}
              >
                <div style={{ fontSize: '20px' }}>{info.emoji}</div>
                {info.displayName}
              </button>
            );
          })}
        </div>

        <label style={{ fontSize: '13px', fontWeight: 600, color: '#444' }}>Title</label>
        <input
          type="text"
          value={title}
          onChange={e => setTitle(e.target.value)}
          placeholder="e.g. Pothole on Bay Road"
          maxLength={80}
          style={{
            width: '100%', padding: '10px 12px', margin: '6px 0 14px',
            border: '1px solid #ddd', borderRadius: '10px', fontSize: '14px',
            boxSizing: 'border-box'
          }}
        />

        <label style={{ fontSize: '13px', fontWeight: 600, color: '#444' }}>Description</label>
        <textarea
          value={description}
          onChange={e => setDescription(e.target.value)}
          placeholder="What should drivers know?"
          rows={3}
          maxLength={500}
          style={{
            width: '100%', padding: '10px 12px', margin: '6px 0 14px',
            border: '1px solid #ddd', borderRadius: '10px', fontSize: '14px',
            boxSizing: 'border-box', resize: 'vertical', fontFamily: 'inherit'
          }}
        />

        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', marginBottom: '18px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={hasLiveChat}
            onChange={e => setHasLiveChat(e.target.checked)}
          />
          Enable live chat on this pin
        </label>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1, padding: '12px', borderRadius: '10px', border: '1px solid #ddd',
              backgroundColor: 'white', cursor: 'pointer', fontSize: '15px', fontWeight: 600
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => isValid && onSubmit(type, title.trim(), description.trim(), hasLiveChat)}
            disabled={!isValid}
            style={{
              flex: 1, padding: '12px', borderRadius: '10px', border: 'none',
              backgroundColor: isValid ? '#007aff' : '#ccc', color: 'white',
              cursor: isValid ? 'pointer' : 'not-allowed', fontSize: '15px', fontWeight: 600
            }}
          >
            Drop Pin
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPinModal;
